// Libarary Class
import { Component, OnInit, ViewEncapsulation, Inject, OnChanges, SimpleChanges, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
const _ = require('lodash');
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { NgbDateStruct, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';

// Service Class
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { SeedFulfillmentService } from './../../../../services/seed/seed-fulfillment.service';

import { ProductLineDeliveryInstructionSliderModelService } from './../../../../common/components/product-line-delivery-instructions/product-line-delivery-instructions-slider-model.service';
import { SeedFulfillmentViewEditBreakdownSliderModelService } from '../../../../common/components/seed-fulfillment-breakdown-view-edit/seed-fulfillment-breakdown-view-edit-slider-model.service';

// Class
import { MasterConstants } from './../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';
import { CommonService } from '../../../../services/common/common.service';
import { DeliveryInstructionsData } from '../../../../common/components/product-line-delivery-instructions/product-line-delivery-instructions.component';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { ShippingAvailabilityService } from '../../../../services/seed/reports/shipping-availability-report.service';
import { BranchPlantVM } from '../../../../models/ShippingAvailability/BranchPlantVM';

@Component({
  selector: 'app-create-edit-seed-fulfillment',
  templateUrl: './create-edit-seed-fulfillment.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ],
  styleUrls: ['./create-edit-seed-fulfillment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateEditSeedFulfillmentComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  submitedItem = false;
  branchPlantData: any = [];
  dashboardFilter: DashboardFilter;
  deliverToData: any;
  freightHandlingCodeData: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  isOverride = false;
  orderViewtoggle = false;
  palletTypeData: any;
  releaseOrder: ReleaseOrder;
  requestTypeData: any;
  shipToData: any;
  displayedColumns: string[] = ['product', 'totalOrderUnits', 'conversionFactor', 'hardSoft', 'eaModifiableUnit', 'availableToRelease', 'releaseQty', 'iconsDisplay'];
  isInventoryVisible = false;
  cropYear: any;
  selectedDealer: any;
  deliverTo: any;
  shipToDataLoading: boolean;
  freightHandlingCodeDataLoading: boolean;
  branchDataLoading: boolean;
  requestTypeDataLoading: boolean;
  palletTypeLoading: boolean;
  canSaveData = false;
  canSaveAndReleaseOrder = false;
  palletArrayItems = new Array();
  accountId: any;
  branchList: object[];
  deliverToLoading: boolean;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  accountEmail: string;
  productLineId: string;
  isNotValid: any;
  column: any;
  selectedValue: any;
  enable: any;
  deliverList: any;
  editToolKit: any;
  selectedCount: any;
  isSearchClicked: any;
  productSearchFilter: any;
  productFilters: any;
  partialSearchValue = '';
  marketingMasterList: any = [];
  filterValueList: any = [];
  searchValue = '';
  productSegmentMasterList: any = [];
  productLineMasterList: any = [];
  productCategoryMasterList: any = [];
  hybridVarietyMasterList: any = [];
  seedSizeMasterList: any = [];
  packageSizeMasterList: any = [];
  treatmentMasterList: any = [];
  orderReleaseDS: MatTableDataSource<any>;
  dealerOrderItemList: any;
  errorsList: Array<string> = [];
  error = false;
  validation: Validation;
  releaseOrderListCopy: any;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  index = 0;
  nextErrorId = 0;
  submitButtonClicked = false;
  isEditMode = false;
  releaseId = 0;
  datemodel: NgbDateStruct;
  dateFilter: any;
  hasChangeAdded = false;
  isReleased = false;
  expandedElement: any | null;
  accessTypeMode = false;
  isDeliveryInstrcutionAccess = false;
  userMenuAccessList: any;
  deliveryInstructionChangeSubscription: any;
  deliveryInstructionAddUpdateChangeSubscription: any;
  releasePalletItems: Array<Object> = [];
  inventoryTypeData: any;
  computeOption: Inventory = Inventory.Compute_All;
  InventoryErrorFlag: string;
  isDeliveryInstructionEmpty = true;
  deliveryInstructionsMasterList: any = [];
  productLineIds: Array<string> = [];
  releaseItemsLotsList: any;
  isWeightComputed = false;
  isComputeDisabled = true;
  totalPalletWeight: number;
  totalSeedWeight: number;
  totalComputedWeight: number;
  isEaEligible: boolean;
  shipToAccountCopy: number;
  isPalletSectionShow: boolean = true;
  selectedBranchPlantList: Array<BranchPlantVM> = [];
  previousPage: string;
  maxDate: Date = new Date();
  minDate: Date = new Date();
  pickupOrderValue: string;
  // Search Type set Up fro grid
  searchTypeList: any[] = [
    { name: 'Product Name', value: 'ProductNameFilter' },
    { name: 'Item Number', value: 'itemNumber' },
    { name: 'Marketing Brand', value: 'marketingBrand' },
    { name: 'Seed Size', value: 'seedSize' },
    { name: 'Package Size', value: 'packageSize' },
    { name: 'Product Category', value: 'productCategory' },
    { name: 'Treatment', value: 'treatment' },
    { name: 'Product Line', value: 'productLine' },
    { name: 'Product Segment', value: 'productSegment' },
    { name: 'Hybrid Variety', value: 'hybridVariety' }
  ];

  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private router: Router,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private seedFulfillmentService: SeedFulfillmentService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private matDialog: MatDialog,
    private config: NgbDatepickerConfig,
    private configDate: NgbCalendar,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private shippingAvailabilityService: ShippingAvailabilityService,
    private productLineDeliveryInstructionSliderModelService: ProductLineDeliveryInstructionSliderModelService,
    private seedFulfillmentViewEditBreakdownSliderModelService: SeedFulfillmentViewEditBreakdownSliderModelService) {
    this.dashboardFilter = new DashboardFilter();
    this.releaseOrder = new ReleaseOrder();
    this.validation = new Validation();
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
    this.subscription.push(this.broadcastService.on<DeliveryInstructionsData>(this.configService.DELIVERY_INSTRUCTION_CHANGE).subscribe((deliveryInstructionsModel) => {
      if (deliveryInstructionsModel && deliveryInstructionsModel.contactId) {
        this.releaseOrder.DeliveryInstructionsNamePhone = deliveryInstructionsModel.firstName + ' ' + deliveryInstructionsModel.phoneNumber;
        if (deliveryInstructionsModel.deliveryCodes && deliveryInstructionsModel.deliveryCodes.length > 0) {
          this.releaseOrder.DeliveryInstructionsCodes = deliveryInstructionsModel.deliveryCodes.join(' ');
        }
        else {
          this.releaseOrder.DeliveryInstructionsCodes = '';
        }
        this.releaseOrder.ContactId = deliveryInstructionsModel.contactId;
        this.releaseOrder.DeliveryInstructions = this.releaseOrder.DeliveryInstructionsNamePhone + (this.releaseOrder.DeliveryInstructionsCodes ? ' ' + this.releaseOrder.DeliveryInstructionsCodes : '');
      }
      else {
        this.resetDeliveryInstruction();
      }
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.DELIVERY_INSTRUCTION_ADD_UPDATE_CHANGE).subscribe((result) => {
      this.deliveryInstructionsMasterList = result;
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.RELEASE_ITEMS_LOTS_ADD_UPDATE_CHANGE).subscribe((result) => {
      if (result) {
        this.enableDisableCompute();
        this.enableDisableSave();
      }
    }));
  }

  ngOnInit() {
    this.submitedItem = this.seedFulfillmentService.submitedItem;

    this.subscription.push(this.shippingAvailabilityService.SelectedBranchPlantList.subscribe(list => {
      this.selectedBranchPlantList = list;
      if (this.selectedBranchPlantList.length > 0) {
        this.releaseOrder.ShipToAccount = this.selectedBranchPlantList[0].accountNumber;
        this.releaseOrder.BranchPlant = this.selectedBranchPlantList[0].branchPlant.toString();
        this.previousPage = "SAR";
        this.computeOption = Inventory.Available_To_Release;
        this.enable = true;
      }
    }));

    if (this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
      this.localStorageService.remove('seedFulfillmentLotsBreakdown');
    }
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
      this.maxDate = new Date(this.headerYear, 11, 31, 23, 59, 59);
      this.releaseOrder.CropYear = this.headerYear;
    }

    this.releaseOrder.CompanyCode = this.headerCompany;
    this.loaderService.setLoaderStatus(true);
    this.resetPalletAndWeight();
    this.productSearchFilter = this.previousPage === "SAR" ? this.searchTypeList[7].value : this.searchTypeList[0].value;
    this.bindDataSource([], true);
    this.getShipToAndDeliverToData();
    this.resetProductFilter();
    this.loadMasterData();
    if (this.previousPage === "SAR") {
      const productLine = this.productLineMasterList.find(y => y.id === this.selectedBranchPlantList[0].productLine);
      if (productLine != undefined) {
        this.productLineId = productLine.value;
        this.productFilters.ProductLineList = [];
        this.filterValueList = [];
        this.productFilters.ProductLineList.push(this.productLineId);
        this.filterValueList.push('Product Line : ' + this.productLineId);
        this.productFilters.IsAvailabilityChecked = true;
        this.subscription.push(this.seedFulfillmentService.getRequestDate(this.selectedBranchPlantList[0].productLine, this.selectedBranchPlantList[0].isBulk).subscribe(result => {
          if (result) {
            this.releaseOrder.RequestedDate = result;
            this.minDate = new Date(result);
            this.minDate = this.minDate > this.maxDate ? this.maxDate : this.minDate;
          }
        }, error => this.loaderService.setLoaderStatus(false)));
      }
    }
    this.canSaveData = false;
    this.canSaveAndReleaseOrder = false;

    this.errorMsgs = new Array();

    this.accessTypeMode = false;
    setTimeout(x => {
      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
        const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
        if (evolveAccessData) {
          this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
          this.accessTypeMode = this.previousPage == "SAR" ? false : this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.FULFILLMENT_TAB, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.isDeliveryInstrcutionAccess = this.previousPage == "SAR" ? true : this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.DELIVERY_INSTRUCTIONS);
        }
      }
    }, 500);

    // Check for EA functionality
    this.isEaEligible = JSON.parse(this.localStorageService.get(MasterConstants.SEED_EA_ACCESS)) ? true : false;

    if (this.previousPage == "SAR") {
      this.computeInventory();
    }
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setSeedEditPageHeight();
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  // Get product list based on account selected
  getProductsList(accountNumber, branchPlant, computeOption) {
    let orderReleaseDSPrevState = [];
    if (accountNumber != null && branchPlant) {
      this.loaderService.setLoaderStatus(true);
      this.dashboardFilter.cropYear = this.headerYear;
      this.dashboardFilter.shipToAccount = accountNumber;
      let rowId: Number = 0;
      // saving the copy of changed quantity to preserve the release qty changw.
      orderReleaseDSPrevState = this.orderReleaseDS.data.filter(x => x.releaseQuantity > 0);
      if (this.releaseId > 0) {
        this.subscription.push(this.seedFulfillmentService.getModifyReleaseOrderItems(this.dashboardFilter.shipToAccount, this.headerYear, this.releaseId, this.releaseOrder.BranchPlant, computeOption).subscribe(result => {
          this.dealerOrderItemList = result;
          this.productLineIds = new Array<string>();
          this.dealerOrderItemList.forEach(product => {
            product.productNameFilter = (product.brand ? product.brand : '') + (product.itemDescription ? product.itemDescription : '') + (product.productLine ? product.productLine : '') + (product.marketingBrand ? product.marketingBrand : '');
            rowId = +rowId + 1;
            product.rowId = +rowId;
            product.lineErrors = { 'rowId': product.rowId, 'errors': [] };

            if (!this.productLineIds.includes(product.productLineId)) {
              this.productLineIds.push(product.productLineId);
            }
          });
          // Altering release qty preseved state back to its original state.
          if (orderReleaseDSPrevState.length > 0) {
            orderReleaseDSPrevState.map((x) => {
              const item = this.dealerOrderItemList.filter(y => y.itemID == x.itemID);
              if (item.length > 0) {
                item[0]['releaseQuantity'] = x.releaseQuantity;
              }
            });
          }
          this.bindDataSource(this.dealerOrderItemList, true);
          if (this.shipToAccountCopy != this.releaseOrder.ShipToAccount) {
            this.shipToAccountCopy = this.releaseOrder.ShipToAccount;
            this.getDeliveryInstructions(this.releaseOrder.DeliverTo ?? accountNumber, this.productLineIds);
          }

          this.computePalletAndSeedWeight();

          this.loaderService.setLoaderStatus(false);
          this.enableDisableSave();
        }, (error => {
          LolLoggerService.error(error);
          this.loaderService.setLoaderStatus(false);
          this.enableDisableSave();
        })));
      }
      else {
        this.resetPalletAndWeight();
        this.subscription.push(this.seedFulfillmentService.getReleaseOrderItems(this.dashboardFilter.shipToAccount, this.headerYear, branchPlant, computeOption).subscribe(result => {
          this.productLineIds = new Array<string>();
          this.dealerOrderItemList = result;
          this.dealerOrderItemList.forEach(product => {
            product.productNameFilter = (product.brand ? product.brand : '') + (product.itemDescription ? product.itemDescription : '') + (product.productLine ? product.productLine : '') + (product.marketingBrand ? product.marketingBrand : '');
            rowId = +rowId + 1;
            product.rowId = +rowId;
            product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
            // to delivery instructions
            if (product.availableUnits > 0) {
              if (!this.productLineIds.includes(product.productLineId)) {
                this.productLineIds.push(product.productLineId);
              }
            }
          });
          // Altering release qty preseved state back to its original state.
          if (orderReleaseDSPrevState.length > 0) {
            orderReleaseDSPrevState.map((x) => {
              const item = this.dealerOrderItemList.filter(y => y.itemID == x.itemID);
              if (item.length > 0) {
                item[0]['releaseQuantity'] = x.releaseQuantity;
              }
            });
          }

          this.bindDataSource(this.dealerOrderItemList, true);
          this.enableDisableSave();
          if (this.shipToAccountCopy != this.releaseOrder.ShipToAccount) {
            this.releaseOrder.ContactId = null;
            this.shipToAccountCopy = this.releaseOrder.ShipToAccount;
            this.getDeliveryInstructions(this.dashboardFilter.shipToAccount, this.productLineIds);
          }

          this.loaderService.setLoaderStatus(false);
        }, (error => {
          LolLoggerService.error(error);
          this.loaderService.setLoaderStatus(false);
          this.enableDisableSave();
        })));
      }
      if (this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
        this.localStorageService.remove('seedFulfillmentLotsBreakdown');
      }
    }
    else {
      this.bindDataSource([], true);
      this.canSaveData = false;
      this.canSaveAndReleaseOrder = false;
      this.loaderService.setLoaderStatus(false);
      this.resetDeliveryInstruction();
      this.productLineIds = new Array<string>();
    }
  }

  // Load the products on change of ship to account
  getShipTo($event) {
    this.selectedDealer = $event;
    if ($event && $event.accountNumber) {
      this.getProductsList($event.accountNumber, this.releaseOrder.BranchPlant, Inventory.None);
    }
    else {
      this.dealerOrderItemList = [];
      this.bindDataSource([], true);
      this.canSaveData = false;
      this.canSaveAndReleaseOrder = false;
      this.resetDeliveryInstruction();
      this.productLineIds = new Array<string>();
    }
    this.revertAllChanges();
  }

  // Branch plant change event check for validation
  OnBranchPlantChange($event) {
    this.validateUserinput('Branch', false);
    if (this.releaseOrder.ShipToAccount) {
      this.getProductsList(this.releaseOrder.ShipToAccount, this.releaseOrder.BranchPlant, Inventory.None);
    }

    if ($event && this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { branchPlantUpdated: true });
    }
  }

  // Freight handling code dropdown change event
  OnFreighthandlingCodeChange($event) {
    this.validateUserinput('FreighthandlingCode', false);
    if ($event && this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { freightHandlingCodeUpdated: true });
    }
  }

  // Deliver to change event add the object to show the deliver to address
  getDeliverToAccount($event) {
    this.deliverTo = $event;
    if ($event && this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
    if ($event && $event.accountNumber) {
      this.getDeliveryInstructions($event.accountNumber, this.productLineIds);
    }
    else {
      if (this.releaseOrder.ShipToAccount) {
        this.getDeliveryInstructions(this.releaseOrder.ShipToAccount, this.productLineIds);
      }
      else {
        this.resetDeliveryInstruction();
      }
    }
  }

  // Get delivery instructions by ship to and deliver account
  getDeliveryInstructions(accountNumber, productLineIds) {
    if (accountNumber != null && accountNumber > 0 && productLineIds.length > 0) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.seedFulfillmentService.getDeliveryInstructions(accountNumber, productLineIds).subscribe(result => {
        let deliveryInstructionsContact = null;
        this.deliveryInstructionsMasterList = result;
        if (result && result.length > 0) {
          if (this.releaseId > 0) {
            if (this.releaseOrder.ContactId) {
              deliveryInstructionsContact = result.filter(x => x.contactId == this.releaseOrder.ContactId)[0];
            }
            else {
              const dealerOrderItems = this.dealerOrderItemList.filter(x => x.releaseQuantity > 0);
              if (dealerOrderItems && dealerOrderItems.length > 0) {
                dealerOrderItems.some(x => {
                  const productLineDeliveryInstructions = result.filter(r => r.productLine == x.productLineId + '-' + (x.packageSize == 'BK' ? '1' : '0'));
                  deliveryInstructionsContact = this.filterProductLineDeliveryInstruction(productLineDeliveryInstructions);
                  if (deliveryInstructionsContact) {
                    return true;
                  }
                });

                if (!deliveryInstructionsContact) {
                  // check for All Bulk and Non Bulk
                  dealerOrderItems.some(x => {
                    const productLineDeliveryInstructions = result.filter(r => r.productLine.toUpperCase() == 'ALL' + '-' + (x.packageSize == 'BK' ? '1' : '0'));
                    deliveryInstructionsContact = this.filterProductLineDeliveryInstruction(productLineDeliveryInstructions);
                    if (deliveryInstructionsContact) {
                      return true;
                    }
                  });
                }
              }
            }
          }

          if (deliveryInstructionsContact && deliveryInstructionsContact.contactId > 0) {
            this.releaseOrder.DeliveryInstructionsNamePhone = deliveryInstructionsContact.firstName + ' ' + deliveryInstructionsContact.phoneNumber;
            this.releaseOrder.DeliveryInstructionsCodes = deliveryInstructionsContact.deliveryCodes && deliveryInstructionsContact.deliveryCodes.length > 0 ? deliveryInstructionsContact.deliveryCodes.join(' ') : '';
            this.releaseOrder.ContactId = deliveryInstructionsContact.contactId;
            this.releaseOrder.DeliveryInstructions = this.releaseOrder.DeliveryInstructionsNamePhone + (this.releaseOrder.DeliveryInstructionsCodes ? ' ' + this.releaseOrder.DeliveryInstructionsCodes : '');
            this.isDeliveryInstructionEmpty = false;
          }
          else {
            this.resetDeliveryInstruction();
          }
        }
        else {
          this.resetDeliveryInstruction();
        }
        this.loaderService.setLoaderStatus(false);
      }, (error => {
        this.loaderService.setLoaderStatus(false);
      })));
    }
    else {
      this.resetDeliveryInstruction();
      this.loaderService.setLoaderStatus(false);
    }
  }

  // select delivery instruction on increase decrease release quantity
  selectDeliveryInstruction() {
    if (!this.releaseOrder.DeliveryInstructionsNamePhone && !this.releaseOrder.ContactId) {
      const result = this.deliveryInstructionsMasterList;
      let deliveryInstructionsContact = null;
      if (result && result.length > 0) {
        const dealerOrderItems = this.dealerOrderItemList.filter(x => x.releaseQuantity > 0);
        if (dealerOrderItems && dealerOrderItems.length > 0) {
          dealerOrderItems.some(x => {
            const productLineDeliveryInstructions = result.filter(r => r.productLine == x.productLineId + '-' + (x.packageSize == 'BK' ? '1' : '0'));
            deliveryInstructionsContact = this.filterProductLineDeliveryInstruction(productLineDeliveryInstructions);
            if (deliveryInstructionsContact) {
              return true;
            }
          });

          if (!deliveryInstructionsContact) {
            // check for All Bulk and Non Bulk
            dealerOrderItems.some(x => {
              const productLineDeliveryInstructions = result.filter(r => r.productLine.toUpperCase() == 'ALL' + '-' + (x.packageSize == 'BK' ? '1' : '0'));
              deliveryInstructionsContact = this.filterProductLineDeliveryInstruction(productLineDeliveryInstructions);
              if (deliveryInstructionsContact) {
                return true;
              }
            });
          }
        }
        if (deliveryInstructionsContact && deliveryInstructionsContact.contactId > 0) {
          this.releaseOrder.DeliveryInstructionsNamePhone = deliveryInstructionsContact.firstName + ' ' + deliveryInstructionsContact.phoneNumber;
          this.releaseOrder.DeliveryInstructionsCodes = deliveryInstructionsContact.deliveryCodes && deliveryInstructionsContact.deliveryCodes.length > 0 ? deliveryInstructionsContact.deliveryCodes.join(' ') : '';
          this.releaseOrder.ContactId = deliveryInstructionsContact.contactId;
          this.releaseOrder.DeliveryInstructions = this.releaseOrder.DeliveryInstructionsNamePhone + (this.releaseOrder.DeliveryInstructionsCodes ? ' ' + this.releaseOrder.DeliveryInstructionsCodes : '');
          this.isDeliveryInstructionEmpty = false;
        }
      }
    }
  }

  // Get delivery instructions by ship to and deliver account
  setDeliveryInstructions(isJdeOrder: boolean) {
    if (this.branchPlantData.length > 0) {
      // var companyCode = this.branchPlantData.find(x => x.id == this.releaseOrder.BranchPlant).data;
      if (!this.releaseOrder.DeliveryInstructionsNamePhone && !this.releaseOrder.ContactId) {
        this.toastrService.error('Please add delivery instruction');
      }
      else {
        if (this.releaseOrder.DeliveryInstructions.length > 60) {
          const ErrorMessages = JSON.parse(
            this.localStorageService.get(MasterConstants.DELIVERY_INSTRUCTIONS_ERROR_MESSAGE)
          );
          if (ErrorMessages.length > 0) {
            this.toastrService.error(ErrorMessages.filter((x) => x.configName == 'DeliveryInstructionMaxLenError')[0].configValue);
          }
        }
        else {
          this.inventoryWarningPopup(isJdeOrder);
        }
      }
    }
  }

  filterProductLineDeliveryInstruction(productLineDeliveryInstructions: any) {
    let deliveryContact;
    if (productLineDeliveryInstructions && productLineDeliveryInstructions.length > 0) {
      deliveryContact = productLineDeliveryInstructions.filter(x => x.contactType == 'P');
      if (!deliveryContact || deliveryContact.length <= 0) {
        deliveryContact = productLineDeliveryInstructions.filter(x => x.contactType == 'S');
      }
      if (deliveryContact && deliveryContact.length > 0) {
        deliveryContact = deliveryContact[0];
      }
    }
    return deliveryContact;
  }
  addDeliveryInstruction() {
    this.productLineDeliveryInstructionSliderModelService.accountNumber = this.releaseOrder.DeliverTo ?? this.releaseOrder.ShipToAccount;
    this.productLineDeliveryInstructionSliderModelService.productLineIds = this.productLineIds;
    this.productLineDeliveryInstructionSliderModelService.releaseContactId = this.releaseOrder.ContactId;
    this.productLineDeliveryInstructionSliderModelService.activeSlider('AddProductLineDeliveryInstructionSlider');
  }

  // open Seed Fulfillment Breakdown screen
  openSeedFulfillmentBreakdown(data: any, isViewOrEdit: string) {
    this.seedFulfillmentViewEditBreakdownSliderModelService.viewEditText = isViewOrEdit;
    this.seedFulfillmentViewEditBreakdownSliderModelService.releaseOrderItem = data;
    this.seedFulfillmentViewEditBreakdownSliderModelService.branchPlant = this.releaseOrder.BranchPlant;
    this.seedFulfillmentViewEditBreakdownSliderModelService.activeSlider('SeedFulfillmentBreakdown');
  }

  // compute pallet and seed weight
  computePalletAndSeedWeight() {
    //hide Add New Pallet for FreightHandlingCode = Parcel
    if (this.releaseOrder.JDEReleaseOrderNumber && this.releaseOrder.ReleaseId) {
      this.loaderService.setLoaderStatus(true);
      this.getReleaseItems();
      this.getReleasePallet();
      this.subscription.push(this.seedFulfillmentService.getPalletAndSeedWeight(this.releaseOrder).subscribe(result => {
        if (result) {
          if (result.releasePalletList && result.releasePalletList.length > 0) {
            this.isPalletSectionShow = true;
          }
          else if (this.releaseOrder.FreightHandlingCode && this.releaseOrder.FreightHandlingCode.toUpperCase() == 'PRC') {
            this.isPalletSectionShow = false;
          }
          else {
            this.isPalletSectionShow = true;
          }
          this.bindPalletsAndSeedsWeight(result);
          this.isComputeDisabled = true;
          this.isWeightComputed = false;
          this.enableDisableSave();
        }
        this.loaderService.setLoaderStatus(false);
      }, (error => {
        this.loaderService.setLoaderStatus(false);
      })));
    }
    else {
      if (this.previousPage == "SAR") {
        this.validateUserinput("PickupOrder", false);
        if (this.error) return false;
      }
      let isBulkNonBulk = false;
      const releaseOrderItems = this.dealerOrderItemList.filter(x => x.releaseQuantity > 0);
      if (releaseOrderItems && releaseOrderItems.length > 0) {
        const bulkNonBulkItems = releaseOrderItems.map(x => x.isBulk).filter((v, i, a) => a.indexOf(v) === i);
        if (bulkNonBulkItems && bulkNonBulkItems.length > 1) {
          isBulkNonBulk = true;
        }
      }

      if (isBulkNonBulk) {
        this.toastrService.error('There is requested quantiles entered for both bulk and non-bulk product. This line is for <Bulk/Packaged> product.');
      }
      else {
        this.loaderService.setLoaderStatus(true);
        this.getReleaseItems();
        this.getReleasePallet();
        this.subscription.push(this.seedFulfillmentService.getPalletAndSeedWeight(this.releaseOrder).subscribe(result => {
          if (result) {
            if (this.previousPage == "SAR") {
              this.releaseOrder.FreightHandlingCode = result.freightHandlingCode;
              this.releaseOrder.JDEVersion = result.jdeVersion;
              this.setOrderTypeType();
            }
            if (this.releaseOrder.FreightHandlingCode && this.releaseOrder.FreightHandlingCode.toUpperCase() == 'PRC') {
              this.isPalletSectionShow = false;
            }
            else {
              this.isPalletSectionShow = true;
            }
            const errorIndex = this.errorsList.findIndex(x => x.indexOf('Total weight for Tuck load Exceeded by') !== -1);
            if (errorIndex >= 0) {
              this.errorsList.splice(this.errorsList.findIndex(x => x.indexOf('Total weight for Tuck load Exceeded by') !== -1));
            }
            this.error = this.errorsList.length > 0;
            let hasErrors = [];
            hasErrors = result.releaseItemsList.filter(x => x.errors.length > 0);
            if (hasErrors.length > 0 || result.errors.length > 0) {
              if (result.errors.length > 0) {
                this.errorsList.push(result.errors.find(x => x.indexOf('Total weight for Tuck load Exceeded by') !== -1));
                this.error = true;
                $('.seedEfulfillmentOuter').scrollTop(0);
              }

              if (hasErrors.length > 0) {
                this.dealerOrderItemList.filter(x => hasErrors.find(y => x.itemID == y.itemId)).forEach(data => {
                  data.lineErrors.errors = [];
                  const itemErrors = result.releaseItemsList.find(result => result.itemId == data.itemID);
                  if (itemErrors) {
                    itemErrors.errors.forEach(itemError => {
                      data.lineErrors.errors.push({ id: itemError.id, error: itemError.error });
                      if (data.lineErrors.errors.length > 0) {
                        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                        this.errorMsgs.push(data.lineErrors);
                        this.getCommonErrors(this.errorMsgs);
                      }
                    });
                  }
                });
                this.isComputeDisabled = true;
              }
            } else {
              this.isComputeDisabled = true;
              this.isWeightComputed = true;
            }
            this.bindPalletsAndSeedsWeight(result);
            this.enableDisableSave();
          }
          this.loaderService.setLoaderStatus(false);
        }, (error => {
          this.loaderService.setLoaderStatus(false);
        })));
      }
    }
  }

  bindPalletsAndSeedsWeight(releaseOrderData: any) {
    this.totalPalletWeight = releaseOrderData.totalPalletWeight;
    this.totalSeedWeight = releaseOrderData.totalSeedWeight;
    this.totalComputedWeight = this.totalPalletWeight + this.totalSeedWeight;

    this.palletArrayItems = [];
    releaseOrderData.releasePalletList.forEach(product => {
      const rowCounter = this.palletArrayItems.length;
      let palletType = product['palletType'];
      const filterPalletType = this.palletTypeData.filter(pt => pt.id == product['itemId'].toString());
      if (filterPalletType && filterPalletType.length > 0) {
        palletType = '';
      }

      this.palletArrayItems.push({
        rowId: rowCounter,
        itemId: product['itemId'].toString(),
        palletQuantity: product['quantity'],
        releaseId: product['releaseId'],
        releasePalletId: product['releasePalletId'],
        palletType: palletType
      });
    });
  }

  resetPalletAndWeight() {
    this.totalPalletWeight = 0;
    this.totalSeedWeight = 0;
    this.totalComputedWeight = 0;
    this.palletArrayItems = [];
  }

  // Request type change event check for validation
  getRequestType($event) {
    this.validateUserinput('RequestType', false);
    if ($event !== undefined) {
      this.releaseOrder.JDEOrderType = $event.orderType;
      this.InventoryErrorFlag = $event.inventoryErrorFlag;
      if (this.isEditMode) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { requestTypeUpdated: true });
      }
    }
  }

  // On edit reintilise the page controls with the values
  getReleaseObject(releaseId) {
    this.isEditMode = true;
    this.displayedColumns = ['product', 'totalOrderUnits', 'conversionFactor', 'hardSoft', 'inventory', 'availableToRelease', 'releaseQty', 'iconsDisplay'];
    this.isInventoryVisible = true;
    this.subscription.push(this.seedFulfillmentService.getReleaseObject(releaseId).subscribe(result => {
      this.releaseOrder.BranchPlant = result['release']['branchPlant'];
      this.releaseOrder.RequestedDate = result['release']['requestedDate'];
      this.selectedDealer = _.find(this.shipToData, { accountNumber: result['release']['shipToAccount'] });
      this.releaseOrder.ShipToAccount = result['release']['shipToAccount'];
      this.deliverTo = _.find(this.deliverToData, { accountNumber: result['release']['deliverTo'] });
      this.releaseOrder.DeliverTo = result['release']['deliverTo'];
      this.releaseOrder.JDEOrderType = result['release']['jdeorderType'];
      this.releaseOrder.JDEVersion = result['release']['jdeversion'];
      // this.releaseOrder.DeliveryInstructions = result['release']['deliveryInstructions'];
      this.releaseOrder.ReleaseId = result['release']['releaseId'];
      this.releaseOrder.FreightHandlingCode = result['release']['freightHandlingCode'];
      this.releaseOrder.JDEReleaseOrderNumber = result['release']['jdereleaseOrderNumber'];
      this.releaseOrder.CustomerPO = result['release']['customerPo'];
      this.releaseOrder.ContactId = result['release']['contactId'];
      this.canSaveData = true;
      this.canSaveAndReleaseOrder = true;

      this.getProductsList(result['release']['shipToAccount'], this.releaseOrder.BranchPlant, Inventory.None);
      const requestType = this.requestTypeData.find(x => x.versionId == this.releaseOrder.JDEVersion);
      if (requestType) {
        this.InventoryErrorFlag = requestType.inventoryErrorFlag;
      }
      this.enableDisableSave();
    }, error => LolLoggerService.error(error)));
  }

  // Get the shipto and  deliver to for dropdown DeliverTo
  getShipToAndDeliverToData() {
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.companyCode = this.headerCompany;
    this.subscription.push(this.seedFulfillmentService.getDeliverToList(MasterConstants.US_COMPANYCODE).subscribe(result => {
      this.deliverToData = result['accounts'];
      this.shipToData = result['accounts']?.filter(x => x.accountType != 'CD');
    }, error => LolLoggerService.error(error)));
  }

  // Load the master data for form
  loadMasterData() {
    this.subscription.push(this.commonService.getMasterData().subscribe((result: any) => {
      const deliveryInstructionMaster = Array<DeliveryInstructionMaster>();
      result.deliveryInstructionsMaster.forEach(item => {
        const deliveryInstruction = new DeliveryInstructionMaster();
        deliveryInstruction.DeliveryCode = item.id;
        deliveryInstruction.Description = item.value;
        deliveryInstructionMaster.push(deliveryInstruction);
      });

      const deliveryInstructionProductLine = Array<DeliveryInstructionProductLine>();
      result.deliveryInstructionsProdLine.forEach(item => {
        const productLines = new DeliveryInstructionProductLine();
        productLines.ProductLineId = item.id;
        productLines.Description = item.value;
        deliveryInstructionProductLine.push(productLines);
      });

      this.productLineDeliveryInstructionSliderModelService.setDeliveryInstructionsMasterData<DeliveryInstructionMaster[]>(deliveryInstructionMaster);
      this.productLineDeliveryInstructionSliderModelService.setDeliveryInstructionsProductLineData<DeliveryInstructionProductLine[]>(deliveryInstructionProductLine);
    }));

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packageSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    if (this.localStorageService.get(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST)) {
      this.productCategoryMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST));
    }
    this.subscription.push(this.commonService.getHybridVarietyMasterData().subscribe((result: any) => {
      this.hybridVarietyMasterList = result;
    }));
    if (this.localStorageService.get(MasterConstants.PRODUCT_SEGMENT_MASTER_LIST)) {
      this.productSegmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_SEGMENT_MASTER_LIST));
    }
    if (this.localStorageService.get(MasterConstants.FREIGHT_HANDLING_CODE_MASTER_LIST)) {
      this.freightHandlingCodeData = JSON.parse(this.localStorageService.get(MasterConstants.FREIGHT_HANDLING_CODE_MASTER_LIST));
    }
    if (this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST)) {
      this.branchPlantData = JSON.parse(this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST));
      this.branchPlantData = this.branchPlantData.filter(x => x.data == this.headerCompany);
      this.branchPlantData.forEach(branch => {
        branch['description'] = branch['id'] + ' - ' + branch['value'];
      });
    }
    if (this.localStorageService.get(MasterConstants.PALLET_LINES_MASTER_LIST)) {
      this.palletTypeData = JSON.parse(this.localStorageService.get(MasterConstants.PALLET_LINES_MASTER_LIST));
    }

    this.subscription.push(this.seedFulfillmentService.getRequestType().subscribe((result: any) => {
      this.requestTypeData = result;
      this.checkRoute();
    }));

    this.inventoryTypeData = [{ id: 1, value: 'Compute for all' }, { id: 2, value: 'Available to release' }, { id: 3, value: 'Do not compute' }];
    this.loaderService.setLoaderStatus(false);
  }


  // set requestType
  setOrderTypeType() {
    if (this.previousPage == "SAR") {
      const requestType = this.requestTypeData.find(x => x.versionId == this.releaseOrder.JDEVersion);
      if (requestType) {
        this.releaseOrder.JDEOrderType = requestType.orderType;
      }
    }
  }
  // Check Route parameters for new/edit item
  checkRoute() {
    this.setOrderTypeType();

    // Get account Id from URL
    this.subscription.push(this.activatedRoute.params.subscribe(x => {
      if (x['releaseId']) {
        const releaseIdTemp = + x['releaseId'];
        if (releaseIdTemp !== 0) {
          this.releaseId = releaseIdTemp;
          this.getReleaseObject(releaseIdTemp);
        } else {
          this.releaseOrder.RequestedDate = new Date();
        }
      }
      if (x['accountNo']) {
        const paramAccountId = + x['accountNo'];
        if (paramAccountId !== 0) {
          this.dashboardFilter.shipToAccount = paramAccountId;
          // At this time the branch plant in releaseorder item is not set so called it in getReleaseObject()
          // this.getProductsList(paramAccountId, this.releaseOrder.BranchPlant);
        }
      }
    }));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // set the selected product filter
  selectProductName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.ProductNameFilter = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.ProductNameFilter = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.ProductNameFilter = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }
    this.keepFilter();
  }

  // set the selected product filter
  selectItemNumber($event) {
    // To check undefined
    if ($event) {
      this.productFilters.ItemNumber = $event.target.value;
    }
    this.keepFilter();
  }

  // Keep the selected filter in case of edit
  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.ProductNameFilter && this.productFilters.ProductNameFilter != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.ProductNameFilter);
        }
        if (this.productFilters.ItemNumber && this.productFilters.ItemNumber != '') {
          this.filterValueList.push('Item Number : ' + this.productFilters.ItemNumber);
        }

        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          let strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }

        // Seed Size
        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSD = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSD = strSD + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSD.substr(0, strSD.length - 2));
        }

        // Package Size
        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          var strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
        }

        // Product Category
        if (this.productFilters.ProductCategoryList && this.productFilters.ProductCategoryList.length > 0) {
          let strPC = '';
          this.productFilters.ProductCategoryList.forEach(x => {
            strPC = strPC + x + ', ';
          });
          this.filterValueList.push('Product Category : ' + strPC.substr(0, strPC.length - 2));
        }

        // Treatment
        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTM = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTM = strTM + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTM.substr(0, strTM.length - 2));
        }

        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }

        // Product Segment
        if (this.productFilters.ProductSegmentList && this.productFilters.ProductSegmentList.length > 0) {
          var strPS = '';
          this.productFilters.ProductSegmentList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Product Segment : ' + strPS.substr(0, strPS.length - 2));
        }

        // Hybrid Variety
        if (this.productFilters.HybridVarietyList && this.productFilters.HybridVarietyList.length > 0) {
          let strHV = '';
          this.productFilters.HybridVarietyList.forEach(x => {
            strHV = strHV + x + ', ';
          });
          this.filterValueList.push('Hybrid Variety : ' + strHV.substr(0, strHV.length - 2));
        }
      }
    }

    this.applyFilterData(this.productFilters);

    // this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Clear the selected filters
  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    const isAvailabilityChecked = this.productFilters.IsAvailabilityChecked;
    this.resetProductFilter();
    this.productFilters.IsAvailabilityChecked = isAvailabilityChecked;
    this.applyFilterData(this.productFilters);
  }

  // Clear single filter
  clearFilter(filterValue) {
    if (!(this.previousPage === 'SAR' && filterValue.includes('Product Line'))) {
      const index = this.filterValueList.indexOf(filterValue);
      this.searchValue = '';
      if (index > -1) {
        this.filterValueList.splice(index, 1);
        // remove product filter
        this.removeProductFilter(filterValue);
        this.applyFilterData(this.productFilters);
        if (this.filterValueList.length < 1) {
          // remove all filter
        }
      }
    }
  }

  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        this.productFilters.ProductNameFilter = '';
        break;
      case 'Item Number':
        this.productFilters.itemNumber = '';
        break;
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        break;
      case 'Product Category':
        this.productFilters.ProductCategoryList = [];
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        break;
      case 'Product Line':
        if (this.previousPage !== 'SAR') {
          this.productFilters.ProductLineList = [];
        }
        break;
      case 'Product Segment':
        this.productFilters.ProductSegmentList = [];
        break;
      case 'Hybrid Variety':
        this.productFilters.HybridVarietyList = [];
        break;
      default:
        break;
    }
  }

  checkAvailability(isAvailabilityChecked: boolean) {
    this.productFilters.IsAvailabilityChecked = isAvailabilityChecked;
    this.keepFilter();
  }

  // Reset delivery instruction
  resetDeliveryInstruction() {
    this.isDeliveryInstructionEmpty = true;
    this.releaseOrder.DeliveryInstructions = '';
    this.releaseOrder.DeliveryInstructionsNamePhone = '';
    this.releaseOrder.DeliveryInstructionsCodes = '';
    this.releaseOrder.ContactId = null;
  }

  // Reset the filters
  resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'ProductNameFilter': null,
      'ItemNumber': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'ProductCategoryList': [],
      'TreatmentList': [],
      'ProductLineList': [],
      'ProductSegmentList': [],
      'HybridVarietyList': [],
      'IsAvailabilityChecked': false
    };
    if (this.previousPage === 'SAR') {
      this.productFilters.ProductLineList.push(this.productLineId);
      this.filterValueList.push('Product Line : ' + this.productLineId);
    }

  }

  // Search based on filter type
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Set initial value for filter
  partialSearch(searchValue: string) {
    if (searchValue != undefined) {
      this.partialSearchValue = searchValue;
    }
  }

  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.orderReleaseDS.filter = filterValue;
  }

  // Dealer unit change and validation
  dealerUnitChange(action: string, productItem: any) {
    // To do
    if (action == 'decrease') {
      const decValue = +productItem.releaseQuantity - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.releaseQuantity;
        productItem.releaseQuantity = Math.floor(productItem.releaseQuantity / +productItem.conv) * +productItem.conv;
        if (valueBeforeDec == productItem.releaseQuantity) {
          productItem.releaseQuantity = (+productItem.releaseQuantity > +productItem.conv ? +productItem.releaseQuantity - +productItem.conv : 0);
        }
      }
      else {
        productItem.releaseQuantity = 0;
      }
    }
    else {
      const valueBeforeInc = productItem.releaseQuantity;
      productItem.releaseQuantity = Math.ceil(productItem.releaseQuantity / +productItem.conv) * +productItem.conv;
      if (valueBeforeInc == productItem.releaseQuantity) {
        productItem.releaseQuantity = (+productItem.releaseQuantity + +productItem.conv);
      }
    }
    this.validateLineItem(productItem, 'releaseUnit');
    if (this.errorMsgs.length <= 0 && action == 'increase') {
      this.selectDeliveryInstruction();
    }
  }

  // Enable Disable save button based on if any product have a quantity > 0
  enableDisableSave() {
    // Commented this condition due to - USerStory#44882

    if (this.isWeightComputed) {
      if (_.filter(this.dealerOrderItemList, item => item.releaseQuantity > 0).length > 0) {
        this.canSaveData = true;
        this.canSaveAndReleaseOrder = true;
      } else {
        // this.canSaveData = false;
        this.canSaveAndReleaseOrder = false;
      }
    }
    else {
      this.canSaveData = false;
      this.canSaveAndReleaseOrder = false;
    }
  }

  // Enable Disable compute button based on if any product have a quantity > 0
  enableDisableCompute() {
    this.isWeightComputed = false;
    this.isComputeDisabled = true;
    if (_.filter(this.dealerOrderItemList, item => item.releaseQuantity > 0).length > 0) {
      const productList = this.orderReleaseDS.data.find(x => x.releaseQuantity > 0);
      if (productList && this.errorMsgs.length <= 0) {
        this.isComputeDisabled = false;
      }
    }
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      if (orderList.length > 0) {
        let rowId: Number = 0;
        orderList.forEach(x => {
          const orderNo = +x.jdeReleaseOrderNumber;
          if (orderNo > 0) {
            this.isReleased = true;
          }
          rowId = +rowId + 1;
          x.rowId = +rowId;
        });
      } else {
        this.canSaveData = false;
        this.canSaveAndReleaseOrder = false;
      }

      if (this.previousPage == "SAR") {
        const sarItemNumber = this.selectedBranchPlantList.map(x => x.itemNumber);
        this.orderReleaseDS = new MatTableDataSource(orderList.filter(item => sarItemNumber.includes(item.itemNumber)));
      }
      else {
        this.orderReleaseDS = new MatTableDataSource(orderList);
      }
      this.enableDisableCompute();
      this.orderReleaseDS.filterPredicate = (data: any, filter: any) => {
        if (data.productNameFilter == null || data.productNameFilter == 'undefined') {
          data.productNameFilter = '';
        }

        if ((filter.ProductNameFilter == null || data.productNameFilter.toLowerCase().indexOf(filter.ProductNameFilter.toLowerCase()) > -1)
          && (filter.itemNumber == null || data.itemNumber.toLowerCase().indexOf(filter.itemNumber.toLowerCase()) > -1)
          && (filter.ProductSegmentList.length == 0 || filter.ProductSegmentList.indexOf(data.productSegment) > -1)
          && (filter.ProductLineList.length == 0 || (filter.ProductLineList.indexOf(data.productLine) > -1))
          && (filter.ProductCategoryList.length == 0 || filter.ProductCategoryList.indexOf(data.technology) > -1)
          && (filter.MarketingBrandList.length == 0 || filter.MarketingBrandList.indexOf(data.marketingBrand) > -1)
          && (filter.HybridVarietyList.length == 0 || filter.HybridVarietyList.indexOf(data.hybridVariety) > -1)
          && (filter.SeedSizeList.length == 0 || filter.SeedSizeList.indexOf(data.seedSize) > -1)
          && (filter.PackageSizeList.length == 0 || filter.PackageSizeList.indexOf(data.packageSize) > -1)
          && (filter.TreatmentList.length == 0 || filter.TreatmentList.indexOf(data.treatment) > -1)
          && (filter.IsAvailabilityChecked == false || data.inventoryQty > 0)) {
          return true;
        }
        else {
          return false;
        }
      };

      this.applyFilterData(this.productFilters);
    }

    // created deep copy
    if (isClone) {
      this.releaseOrderListCopy = JSON.parse(JSON.stringify(orderList));
    }
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
  }

  // Delivery instruction key up event
  deliveryInstructionChange() {
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliveryInstructionsUpdated: true });
    }
  }

  // Add new Item to the palletType Table
  addPalletType() {
    if (this.palletTypeData.length === 0) {
      this.toastrService.info('No Pallet Line data available for addition.');
      return;
    } else {
      const rowCounter = this.palletArrayItems.length;
      this.palletArrayItems.push({
        rowId: rowCounter,
        itemId: new Number(),
        palletQuantity: 0,
        releaseId: 0,
        releasePalletId: 0,
        palletType: ''
      });
    }
  }

  setPalletItem($event, rowId, palletQuantity) {
    this.palletArrayItems.forEach(pallet => {
      if (pallet.rowId == rowId) {
        pallet.rowId = rowId;
        pallet.itemId = $event.id;
        pallet.palletQuantity = palletQuantity;
      }
    });
    this.enableDisableCompute();
    this.enableDisableSave();
  }

  palletQuantityChange(rowId, palletQuantity) {
    this.palletArrayItems.forEach(pallet => {
      if (pallet.rowId == rowId) {
        pallet.rowId = rowId;
        pallet.palletQuantity = palletQuantity;
      }
    });
    this.enableDisableCompute();
    this.enableDisableSave();
  }

  // Validate date
  validateDate($event) {
    const currentDate = new Date();
    if ($event.value < currentDate) {
      this.releaseOrder.RequestedDate = currentDate;
      if (this.isEditMode) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { requestedDateUpdated: true });
        this.validateUserinput('RequestDate', true);
      }
    }
  }



  // Save & update release and release item data
  saveReleaseOrder() {
    this.submitButtonClicked = true;
    this.validateUserinput('Both', false);
    if (!this.error && !(this.errorMsgs.length > 0)) {
      const title = 'Please confirm only saving this request for fulfillment.';
      const message = 'This request will be saved and may be later submitted for fulfillment in the ERP system. The request will remain in the Unsubmitted Drafts group.';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Confirm', labelNo: 'Cancel', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.setDeliveryInstructions(false);
        }
      }));
    }
  }
  // Place release order
  placeReleaseOrder() {
    this.getReleaseItems();
    this.getReleasePallet();
    this.subscription.push(this.seedFulfillmentService.addUpdateReleaseOrder(this.releaseOrder).subscribe((result: any) => {
      if (result.errors.length > 0) {
        this.loaderService.setLoaderStatus(false);
        result.errors.forEach(x => {
          this.toastrService.error(x);
          return false;
        });
      }
      else {
        if (result.releaseId > 0) {
          if (this.isEditMode) {
            this.toastrService.success('Release Order #' + result.releaseId + ' updated successfully.');
          } else {
            this.toastrService.success('Release Order #' + result.releaseId + ' saved successfully.');
          }

          this.navigateToSeedfulfillment();
        }
        else {
          this.dealerOrderItemList.forEach(data => {
            data.lineErrors.errors = [];
            const matchedItem = result.releaseItemsList.find(result => result.itemId == data.itemID);
            if (matchedItem) {
              data.availableUnits = matchedItem.availableUnits;
              data.hardQuantity = matchedItem.hardQuantity;
              data.softQuantity = matchedItem.softQuantity;
              data.inventoryQty = matchedItem.inventoryQty;
            }

            const itemErrors = result.releaseItemsList.find(result => result.itemId == data.itemID);
            if (itemErrors) {
              itemErrors.errors.forEach(itemError => {
                data.lineErrors.errors.push({ id: itemError.id, error: itemError.error });

                if (data.lineErrors.errors.length > 0) {
                  this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                  this.errorMsgs.push(data.lineErrors);
                  this.getCommonErrors(this.errorMsgs);
                }
              });
            }
          });

          this.releaseOrderListCopy.forEach(item => {
            const newLineValue = this.dealerOrderItemList.filter(x => x.rowId == item.rowId)[0];
            item.availableUnits = newLineValue.availableUnits;
            item.hardQuantity = newLineValue.hardQuantity;
            item.softQuantity = newLineValue.softQuantity;
            item.inventoryQty = newLineValue.inventoryQty;
            item.lineErrors.errors = [];
          });
          this.bindDataSource(this.dealerOrderItemList, false);
        }
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get release items for a product to be saved/updated
  getReleaseItems() {
    this.loaderService.setLoaderStatus(true);
    this.releaseOrder.ReleaseItemsList = new Array();
    this.releaseOrder.ReleaseItemsLots = new Array();
    this.releaseOrder.isOverrideOn = this.isOverride;
    let seedFulfillmentBreakdownLots;
    if (this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
      seedFulfillmentBreakdownLots = JSON.parse(this.localStorageService.get('seedFulfillmentLotsBreakdown'));
    }
    this.dealerOrderItemList.forEach(product => {
      let releaseItem: ReleaseItem;

      releaseItem = new ReleaseItem();
      releaseItem.ReleaseItemId = product.releaseItemId;
      releaseItem.DealerOrderItemId = product.dealerOrderItemId;
      releaseItem.ItemId = product.itemID;
      releaseItem.Quantity = product.releaseQuantity;
      releaseItem.UOM = product.primaryUOM;
      releaseItem.InventoryQty = product.inventoryQty;
      releaseItem.ItemNumber = product.itemNumber;
      releaseItem.Status = 'A';
      releaseItem.ProductLineId = product.productLineId;
      releaseItem.IsBulk = product.isBulk;
      releaseItem.IsCBOX = product.isCBOX;
      releaseItem.PackageSize = product.packageSize;
      releaseItem.PackageSizeId = product.packageSizeId;
      this.releaseOrder.DealerOrderId = product.dealerOrderID;
      this.releaseOrder.IsSarRequest = this.previousPage == 'SAR';
      this.releaseOrder.PickupOrder = this.pickupOrderValue;
      this.releaseOrder.IsBulk = this.previousPage == 'SAR' ? this.selectedBranchPlantList[0].isBulk : 'N';
      this.releaseOrder.ReleaseItemsList.push(releaseItem);
      if (seedFulfillmentBreakdownLots) {
        const releaseItemsLotsSettings = seedFulfillmentBreakdownLots.filter(lots => lots.itemNumber === product.itemNumber && lots.lotLocationReleaseQuantity > 0);
        if (releaseItemsLotsSettings && releaseItemsLotsSettings.length > 0) {
          releaseItemsLotsSettings.forEach(lotSettings => {
            const releaseItemLot = new ReleaseItemsLots();
            releaseItemLot.itemId = product.itemID;
            releaseItemLot.location = lotSettings.location;
            releaseItemLot.lotNumber = lotSettings.lot;
            releaseItemLot.productWeight = lotSettings.weight;
            releaseItemLot.quantity = lotSettings.lotLocationReleaseQuantity;
            releaseItemLot.releaseItemId = product.releaseItemId;
            releaseItemLot.itemNumber = lotSettings.itemNumber;

            this.releaseOrder.ReleaseItemsLots.push(releaseItemLot);
          });
        }
      }
    });

    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
  }

  // Get release pallet for a product to be saved/updated
  getReleasePallet() {
    this.loaderService.setLoaderStatus(true);
    this.releaseOrder.ReleasePalletList = new Array();
    const items = this.releasePalletItems;
    this.palletArrayItems.forEach(pallet => {
      let releasePallet: ReleasePallet;
      releasePallet = new ReleasePallet();
      if (pallet.palletQuantity > 0 && pallet.itemId > 0) {
        releasePallet.ReleaseId = this.releaseId;
        releasePallet.ReleasePalletId = pallet.releasePalletId;
        releasePallet.ItemId = pallet.itemId;
        releasePallet.Quantity = pallet.palletQuantity;
        releasePallet.PalletType = pallet.palletType;
        this.releaseOrder.ReleasePalletList.push(releasePallet);
      }
    });
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
  }

  // Validate input
  validateInput(data: any, message: string) {
    if ((typeof (data) === 'undefined' || data === null || (data == '' && message.indexOf('Freight') <= 0))) {
      if (!(this.errorsList.indexOf(message) > -1)) {
        this.errorsList.push(message);
      }
      return true;
    } else {
      return false;
    }
  }

  // Validate the validations
  validateUserinput(validate: string, checkRequestedDate: boolean) {
    this.error = false;
    this.errorsList = [];
    if (validate === 'Branch') {
      this.validation.BranchPlant = this.validateInput(this.releaseOrder.BranchPlant, 'Please select Branch');
    }
    else if (validate === 'RequestType') {
      this.validation.JDEVersion = this.validateInput(this.releaseOrder.JDEVersion, 'Please select RequestType');
    }
    else if (validate === 'FreighthandlingCode') {
      this.validation.FreightHandlingCode = this.validateInput(this.releaseOrder.FreightHandlingCode, 'Please select Freight Handling Code');
    }
    else if (validate === 'PickupOrder') {
      this.validation.PickupOrder = this.validateInput(this.pickupOrderValue, 'Please select Pickup Order');
    }

    if (validate === 'Both' || this.submitButtonClicked) {
      this.validation.BranchPlant = this.validateInput(this.releaseOrder.BranchPlant, 'Please select Branch');
      this.validation.JDEVersion = this.validateInput(this.releaseOrder.JDEVersion, 'Please select RequestType');
      this.validation.FreightHandlingCode = this.validateInput(this.releaseOrder.FreightHandlingCode, 'Please select Freight Handling Code');
    }
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    const reqDate = new Date(this.releaseOrder.RequestedDate);
    if (checkRequestedDate && reqDate < todayDate) {
      this.validation.RequestedDate = true;
      if (!(this.errorsList.indexOf('Requested date should be greater than or equal to today') > -1)) {
        this.errorsList.push('Requested date should be greater than or equal to today');
      }
    }

    if (this.errorsList.length !== 0) {
      this.error = true;
      $('.seedEfulfillmentOuter').scrollTop(0);
    } else {
      this.resetValidations();
    }
  }

  // rest validations
  resetValidations() {
    this.validation.BranchPlant = false;
    this.validation.JDEVersion = false;
    this.validation.RequestedDate = false;
    this.validation.FreightHandlingCode = false;
  }

  // Reset page
  resetPageData() {
    if (this.isReleased) {
      this.navigateToSeedfulfillment();
    }
    else {
      if (this.hasChangeAdded == true) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });
        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
            this.resetData();
          }
        }));
      } else {
        this.resetData();
      }
    }
  }

  // Reset data
  resetData() {
    this.shipToData = [];
    this.deliverToData = [];
    this.freightHandlingCodeData = [];
    this.requestTypeData = [];
    this.branchPlantData = [];
    this.releaseOrder = new ReleaseOrder();
    this.selectedDealer = undefined;
    this.deliverTo = undefined;
    this.bindDataSource([], false);
    this.accountEmail = '';
    this.revertAllChanges();
    this.resetValidations();
    this.error = false;
    this.ngOnInit();
  }

  // Open the inventory warning popup when inventory column is visible and inventoryQty < availableQty and InventoryErrorFlag === "W"
  inventoryWarningPopup(isJdeOrder: boolean) {
    const showWarning = this.dealerOrderItemList.find(product => product.inventoryQty < product.releaseQuantity);
    if (this.isInventoryVisible && this.InventoryErrorFlag === 'W' && showWarning) {
      const title = 'Warning';
      const message = 'Inventory Quantity is less than Release Quantity. Would you like to proceed?';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          if (isJdeOrder) {
            this.placeJdeOrderRequest();
          } else {
            this.placeReleaseOrder();
          }
        }
      }));
    } else {
      if (isJdeOrder) {
        this.placeJdeOrderRequest();
      } else {
        this.placeReleaseOrder();
      }
    }
  }

  // Popup on JDEOrder button click gets open
  placeJdeOrder() {
    this.submitButtonClicked = true;
    this.validateUserinput('Both', true);
    if (!this.error && !(this.errorMsgs.length > 0)) {
      const title = 'Please confirm saving this request, and submission to create fulfillment order in ERP system.';
      const message = 'Once this request is submit, it may not be changed. The request will be available for viewing in the Submitted Requests group.';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Confirm', labelNo: 'Cancel', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.setDeliveryInstructions(true);
        }
      }));
    }
  }
  // Place JDE order request
  placeJdeOrderRequest() {
    this.getReleaseItems();
    this.getReleasePallet();
    this.subscription.push(this.seedFulfillmentService.placeJDEOrder(this.releaseOrder).subscribe((result: any) => {
      if (result.errors.length > 0) {
        this.loaderService.setLoaderStatus(false);
        result.errors.forEach(x => {
          this.toastrService.error(x);
          return false;
        });
      }
      else {
        if (this.previousPage == "SAR") {
          this.releaseOrder.FreightHandlingCode = result.freightHandlingCode;
          this.releaseOrder.JDEVersion =  result.jdeVersion;
          this.setOrderTypeType();
        }
        if (result.releaseId > 0) {

          // IF JDE Not Transfer sucessfully then show the error(toast time increse upto 5+4=9 second(default is 5000ms in app module))
          if (result.incidentNumber && result.incidentNumber.length > 0) {
            this.toastrService.error(
              'Error submitting release: Release saved to drafts folder, see line for more details.',
              '',
              { timeOut: 9000, extendedTimeOut: 2000, closeButton: true }
            );
          }
          else {
            if (this.isEditMode) {
              if (result.submitFailedMessage == 'OK') {
                this.toastrService.success('Release Order #' + result.releaseId + ' updated and released successfully.');
              }
              else {
                this.toastrService.success('Release Order #' + result.releaseId + ' updated. ' + result.submitFailedMessage);
              }
            }
            else {
              if (result.submitFailedMessage == 'OK') {
                this.toastrService.success('Release Order #' + result.releaseId + ' saved and released successfully.');
              }
              else {
                this.toastrService.success('Release Order #' + result.releaseId + ' saved. ' + result.submitFailedMessage);
              }
            }
          }
          this.navigateToSeedfulfillment();
        }
        else {
          this.dealerOrderItemList.forEach(data => {
            data.lineErrors.errors = [];
            const matchedItem = result.releaseItemsList.find(result => result.itemId == data.itemID);
            if (matchedItem) {
              data.availableUnits = matchedItem.availableUnits;
              data.hardQuantity = matchedItem.hardQuantity;
              data.softQuantity = matchedItem.softQuantity;
              data.inventoryQty = matchedItem.inventoryQty;
            }

            const itemErrors = result.releaseItemsList.find(result => result.itemId == data.itemID);
            if (itemErrors) {
              itemErrors.errors.forEach(itemError => {
                data.lineErrors.errors.push({ id: itemError.id, error: itemError.error });

                if (data.lineErrors.errors.length > 0) {
                  this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                  this.errorMsgs.push(data.lineErrors);
                  this.getCommonErrors(this.errorMsgs);
                }
              });
            }
          });

          this.releaseOrderListCopy.forEach(item => {
            const newLineValue = this.dealerOrderItemList.filter(x => x.rowId == item.rowId)[0];
            item.availableUnits = newLineValue.availableUnits;
            item.hardQuantity = newLineValue.hardQuantity;
            item.softQuantity = newLineValue.softQuantity;
            item.inventoryQty = newLineValue.inventoryQty;
            item.lineErrors.errors = [];
          });
          this.bindDataSource(this.dealerOrderItemList, false);
        }
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Line item validation
  validateLineItem(item: any, validateField) {
    this.isWeightComputed = false;
    let seedFulfillmentBreakdownLots;
    if (this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
      seedFulfillmentBreakdownLots = JSON.parse(this.localStorageService.get('seedFulfillmentLotsBreakdown'));
    }
    this.enableDisableSave();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productQuantityUpdated: true });

    const oldLineValue = this.releaseOrderListCopy.filter(x => x.rowId == item.rowId)[0];
    if (validateField != '') {
      if (validateField == 'releaseUnit') {
        let unitsToMatch = 0;
        if (this.isEditMode) {
          unitsToMatch = +(item.releaseQuantity - oldLineValue.releaseQuantity);
        }
        else {
          unitsToMatch = +(item.releaseQuantity);
        }

        if (item.availableUnits < unitsToMatch) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
          item.lineErrors.errors.push({
            id: 'availableUnits', error: 'Release Qty entered cannot exceed the Available to Release qty. ' + item.availableUnits + ' equivalent units left to ship.'
          });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }

        if (unitsToMatch != 0 && unitsToMatch % item.conv != 0) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
          item.lineErrors.errors.push({ id: 'conv', error: 'Please re-enter your Release Qty in multiples of ' + item.conv });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }

        if (seedFulfillmentBreakdownLots) {
          const releaseItemsLotsSettings = seedFulfillmentBreakdownLots.filter(lots => lots.itemNumber === item.itemNumber && lots.lotLocationReleaseQuantity > 0);
          if (releaseItemsLotsSettings && releaseItemsLotsSettings.length > 0) {
            let lotsReleaseQuantity = 0;
            releaseItemsLotsSettings.forEach(lotSettings => {
              lotsReleaseQuantity += lotSettings.lotLocationReleaseQuantity;
            });
            if (lotsReleaseQuantity != item.releaseQuantity) {
              item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'lotsReleaseQuantityMisMatch');
              item.lineErrors.errors.push({ id: 'lotsReleaseQuantityMisMatch', error: 'Lot location release quanity does not match with release quantity' });
            }
            else {
              item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'lotsReleaseQuantityMisMatch');
              this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
            }
          }
        }
      }
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    this.enableDisableCompute();
    return item;
  }

  // Hide/show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.releaseOrderListCopy.length > 0 && this.orderReleaseDS.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.releaseOrderListCopy.filter(x => x.rowId == element.rowId)[0];

        // get current object index
        const currentLineIndex = this.orderReleaseDS.data.findIndex(x => x.rowId == element.rowId);

        if (this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
          this.errorMsgs.filter(x => {
            if (x.errors[0].id == 'lotsReleaseQuantityMisMatch') {
              const seedFulfillmentLots = JSON.parse(this.localStorageService.get('seedFulfillmentLotsBreakdown'));
              const seedFulfillmentLotsFilterData = seedFulfillmentLots.filter(lots => lots.itemNumber !== element.itemNumber);
              this.localStorageService.remove('seedFulfillmentLotsBreakdown');
              this.localStorageService.set('seedFulfillmentLotsBreakdown', JSON.stringify(seedFulfillmentLotsFilterData));
            }
          });
        }

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.orderReleaseDS.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.bindDataSource(this.orderReleaseDS.data, false);

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
        }

        this.index = 0;
        this.currentErrorRow = 1;
      }
      else {
        // To hide all errors after revert all changes
        this.orderReleaseDS.data.forEach(x => {
          if (x.lineErrors.errors.length != 0) {
            const index = x.lineErrors.rowId - 1;
            const oldLineValue = this.releaseOrderListCopy.filter(x => x.rowId - 1 == index)[0];

            if (this.orderReleaseDS.data[index].lineErrors.errors[0].id === 'lotsReleaseQuantityMisMatch'
              && this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
              const seedFulfillmentLots = JSON.parse(this.localStorageService.get('seedFulfillmentLotsBreakdown'));
              const seedFulfillmentLotsFilterData = seedFulfillmentLots.filter(lots => lots.itemNumber !== this.orderReleaseDS.data[index].itemNumber);
              this.localStorageService.remove('seedFulfillmentLotsBreakdown');
              this.localStorageService.set('seedFulfillmentLotsBreakdown', JSON.stringify(seedFulfillmentLotsFilterData));
            }

            this.orderReleaseDS.data[index] = JSON.parse(JSON.stringify(oldLineValue));
            this.showHideLineError(index);
          }
        });

        this.bindDataSource(this.dealerOrderItemList, false);
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    this.enableDisableSave();
    this.enableDisableCompute();
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView').scrollTop = 0;
      const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
      $('#orderView').animate({ scrollTop: nextOffset }, 1000);
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView').scrollTop = 0;
      $('#orderView').animate({ scrollTop: 0 }, 1000);
    }
    this.enableDisableSave();
    this.enableDisableCompute();
  }

  // Revert all changes
  revertAllChanges() {
    this.index = 0;
    this.currentErrorRow = 1;
    this.revertToPreviousError([], false);
    this.hideCommonError();
    this.enableDisableSave();
    this.enableDisableCompute();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }
  // Go to landing seed fulfillment page
  navigateToSeedfulfillment() {
    if (this.previousPage == "SAR") {
      this.router.navigate(['reports/shipping-availability-report']);
    }
    else {
      this.router.navigate(['/seed-fulfillment']);
    }
  }

  computeInventory() {
    this.hideCommonError();
    this.getProductsList(this.releaseOrder.ShipToAccount, this.releaseOrder.BranchPlant, this.computeOption);
    if (this.computeOption == 3) {
      this.displayedColumns = ['product', 'totalOrderUnits', 'conversionFactor', 'hardSoft', 'eaModifiableUnit', 'availableToRelease', 'releaseQty', 'iconsDisplay'];
      this.isInventoryVisible = false;
    } else {
      this.displayedColumns = ['product', 'totalOrderUnits', 'conversionFactor', 'hardSoft', 'eaModifiableUnit', 'inventory', 'availableToRelease', 'releaseQty', 'iconsDisplay'];
      this.isInventoryVisible = true;
    }
  }

  removePalletItem(index: number) {
    this.palletArrayItems.splice(index, 1);
    this.enableDisableCompute();
    this.enableDisableSave();
  }

  toggleOverrideOnly() {
    this.isOverride = !this.isOverride;
    this.enableDisableCompute();
    this.enableDisableSave();
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
    this.shippingAvailabilityService.setSelectedBranchPlantList([]);
    if (this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
      this.localStorageService.remove('seedFulfillmentLotsBreakdown');
    }
  }
}
// Class model for Release
export class ReleaseOrder {
  BranchPlant: string;
  ReleaseId: number;
  CropYear: number;
  CompanyCode: string;
  DealerOrderId: number;
  JDEOrderType: string;
  JDEVersion: string;
  ShipToAccount: number;
  FreightHandlingCode: string;
  DeliverTo: number;
  RequestedDate: Date;
  DeliveryCode: string;
  DeliveryInstructionsCodes: string;
  DeliveryInstructionsNamePhone: string;
  DeliveryInstructions: string;
  ReleaseItemsList: Array<ReleaseItem> = [];
  JDEReleaseOrderNumber: number;
  CustomerPO: string;
  ReleasePalletList: Array<ReleasePallet> = [];
  ContactId: number;
  isOverrideOn = false;
  ReleaseItemsLots: Array<ReleaseItemsLots> = [];
  IsSarRequest: boolean;
  PickupOrder: string;
  IsBulk: string;
}

// Class model for delivery instruction master drop down
export class DeliveryInstructionMaster {
  DeliveryCode: string;
  Description: string;
}

// Class model for delivery instruction master drop down
export class DeliveryInstructionProductLine {
  ProductLineId: string;
  Description: string;
}

// Class model for items list for lot
export class ItemsList {
  ItemNumber: string;
  BranchPlant: string;
  ItemUOM: string;
}

// Class model for Release Item
export class ReleaseItem {
  DealerOrderItemId: number;
  ReleaseItemId: number;
  ItemId: number;
  JDELineNumber: any;
  Quantity: any;
  UOM: string;
  InventoryQty: number;
  Status: string;
  ItemNumber: string;
  ProductLineId: string;
  IsBulk: string;
  IsCBOX: string;
  PackageSize: string;
  PackageSizeId: string;
}
// Class for Validation check
export class Validation {
  JDEVersion = false;
  BranchPlant = false;
  RequestedDate = false;
  FreightHandlingCode = false;
  PickupOrder = false;
}
// Class model for Release Pallet
export class ReleasePallet {
  ReleasePalletId: number;
  ReleaseId: number;
  ItemId: number;
  Quantity: number;
  PalletType: string;
}

enum Inventory {
  None = 0,
  Compute_All = 1,
  Available_To_Release = 2,
  Do_Not_Compute = 3
}
export class ReleaseItemsLots {
  itemId: number;
  releaseItemId: number;
  lotNumber: string;
  location: string;
  productWeight: number;
  quantity: number;
  itemNumber: string;
}
